import React from 'react';
import Logo from 'components/common/Logo';
import { Outlet } from 'react-router-dom';
import './layout-tw.scss';

const PublicLayout = () => {
  return (
    <section className="tw-py-0">
      <div className="ptl-container">
        <div className="tw-flex tw-items-center tw-justify-center tw-min-h-screen tw-py-12">
          <div className="tw-w-full tw-max-w-3xl">
            <div className="tw-flex tw-justify-center tw-mb-2">
              <Logo />
            </div>
            <Outlet />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PublicLayout;
